import moment from "moment";
import SvgIcon from "../../../../../parts/SvgIcon";

function eventOnDay(event, dayUtc) {
  if (event.fromDate > dayUtc) return false;
  if (event.toDate) return event.toDate >= dayUtc;
  return event.fromDate === dayUtc;
}

function PlanAnnualEventCard({ annualEvents, dayKey }) {
  if (!annualEvents || annualEvents.length === 0 || !dayKey) return null;
  const dayUtc = parseInt(moment(dayKey, "YYYY-MM-DD").format("YYYYMMDD"), 10);
  const eventsForDay = annualEvents.filter((e) => eventOnDay(e, dayUtc));
  if (eventsForDay.length === 0) return null;
  return (
    <>
      {eventsForDay.map((e) => (
        <div key={e._id} className="plan-card plan-card--event">
          <div className="plan-card__header">
            <SvgIcon src="/img/new-icons/calendar.svg" useCurrentColor={true} />
            {e.name}
          </div>
        </div>
      ))}
    </>
  );
}

export default PlanAnnualEventCard;
